import React, { Component } from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {Alert, Button, Card, CardBody, CardTitle} from 'reactstrap';

import {changeUpdatesStatus, fetchAlertNotifications, fetchNewAlertNotifications} from '../../actions/alertActions';
import {fetchCompanies} from '../../actions/companyActions';
import {closeAlert} from '../../actions/commonsActions';
import {COMPANY_ADMIN, PAGINATION_DEFAULT_LIMIT, USER_ROLES} from '../../helpers/constants';
import {I18n} from '../../I18n/components/alerts';
import NotificationsList from './NotificationsList';
import './alertNotifications.css';

class AlertNotifications extends Component {
	constructor(props) {
		super(props);
		this.state = {
			companyId: null,
			currentPage: 0
		};
	}

	componentDidMount() {
		if (this.props.authority === COMPANY_ADMIN) {
			// if (!this.props.companies[0]) {
			// 	await this.props.fetchCompanies();
			// }
			(async () => {
				try {
					// await this.props.fetchNewAlertNotifications({
					// 	companyId: this.props.companies[0].id,
					// 	page: 0,
					// 	limit: PAGINATION_DEFAULT_LIMIT,
					// });
					await this.props.fetchAlertNotifications({
						companyId: this.props.companies[0].id,
						page: 0,
						limit: 25
					});
				} catch(error) {
					console.log(error);
				}
			})();
		}
	}

	fetchPaginatedData = currentPage => {
		this.props.fetchAlertNotifications({
			companyId: this.props.companies[0].id,
			page: currentPage,
			limit: 25
		});
	};

	setCurrentPage = currentPage => {
		this.setState({
			currentPage
		}, () => {
			this.fetchPaginatedData(currentPage);
		});
	};

	declineHandler = id => {
		console.log('decline', id)
	};

	updateHandler = id => {
		console.log('update', id)
	};

	confirmAllHandler = async () => {
		try {
			await this.props.confirmAllUpdates({
				companyId: this.props.companies[0].id ? this.props.companies[0].id : null,
				type: 'ACCEPTED',
				userEmail: this.props.currentUser.email
			});
			await this.props.fetchNewAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
			await this.props.fetchAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
		}
		catch (error) {
			console.log(error)
		}
	};

	declineAllHandler = async () => {
		try {
			await this.props.declineAllUpdates({
				companyId: this.props.companies[0].id ? this.props.companies[0].id : null,
				type: 'DECLINED',
				userEmail: this.props.currentUser.email
			});
			await this.props.fetchNewAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
			await this.props.fetchAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
		}
		catch (error) {
			console.log(error)
		}
	};

	render() {
		const {lang, loading, alertNotifications, pagination, newAlertsLoading, newAlertsTotal} = this.props;
		const notifications = loading || newAlertsLoading ? <div className="loading">Loading...</div> : <NotificationsList
			lang={lang}
			data={alertNotifications}
			currentPage={this.state.currentPage}
			setCurrentPage={this.setCurrentPage}
			totalPages={pagination.totalPages}
			declineHandler={this.declineHandler}
			updateHandler={this.updateHandler}
		/>
		return (
			<div className="alertsNotifications">
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].notificationsList_title}
						</div>
						{
							newAlertsTotal !== 0 ? <div className="alertsNotifications__btns">
								<Button
									color="secondary"
									type="button"
									size="sm"
									onClick={this.declineAllHandler}
								>
									{I18n[lang].cancel}
								</Button>
								<Button
									color="primary"
									type="button"
									size="sm"
									onClick={this.confirmAllHandler}
								>{I18n[lang].update} ( {newAlertsTotal} )
								</Button>
							</div> : null
						}
					</CardTitle>
					<CardBody>
						{notifications}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: (url) => dispatch(push(url)),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		fetchAlertNotifications: (query) => dispatch(fetchAlertNotifications(query)),
		fetchNewAlertNotifications: (query) => dispatch(fetchNewAlertNotifications(query)),
		confirmAllUpdates: (query) => dispatch(changeUpdatesStatus(query)),
		declineAllUpdates: (query) => dispatch(changeUpdatesStatus(query)),
	};
};

const mapStateToProps = state => ({
	alertNotifications: state.alertNotificationsReducer.alertNotifications,
	newAlertsLoading: state.alertNewNotificationsReducer.loading,
	newAlertsTotal: state.alertNewNotificationsReducer.totalElements,
	pagination: state.alertNotificationsReducer.pagination,
	loading: state.alertNotificationsReducer.loading,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	currentUser: state.currentUser,
	companies: state.companiesReducer.companies,
	lang: state.languageReducer.lang,
	alert: state.alert
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertNotifications)



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertNotifications.js